import { makeEditorModal } from '../Modal';
import { Editor } from 'tinymce';
import { b64ToImg, editing, getData, insertToEditor, selectNode, setWindowNode, toJsonHtml } from '../core/Utils';
import { FeatureClass } from '../core/FeatureClass';
import { getFunctionData, renderCurrentFunction } from './PlotFunction';
import { dateId, uniqueRandomId } from '../save/SaveUtils';
import { turnPictureToLabelingTask } from '../Inputs/Labeling';

export interface graphAxis {
    label?: string
    domain?: boolean|Array<number>
}

export interface GraphData {
    type?: string;
    url?: string;
    width?: number;
    height?: number;
    id?: string;
    functions: Array<Function>,
    grid: boolean,
    integral: boolean;
    xAxis: graphAxis;
    yAxis: graphAxis;
}

interface Function {
    fn: string;
}

const defaultGraph = {
    functions: [{fn: ''}],
    xAxis: {
        label: '',
        domain: [-10, 10]
    },
    yAxis: {
        label: '',
        domain: [-4, 4]
    },
    grid: false,
    integral: false,
}

export function addGraph(editor:Editor){
    
    const config = {
        featureName: "graph",
        editor: editor,
        id: "graph",
        icon: "graph",
        tooltip: 'Graph erstellen',
        menuItems: [{
            name: 'edit-graph',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);

                data.width = $(node).attr('width').replace("px", "");
                data.height = $(node).attr('height').replace("px", "");

                createGraphModal(editor, command, data);
            }
        }],
        buttonAction: (command:string) => {
            createGraphModal(editor, command, defaultGraph);
        },
        commandAction: (data:GraphData) => {
            insertGraph(data, editor);
        }    
    }
    config.menuItems.push(turnPictureToLabelingTask())

    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}

export function addGraphListeners(){
    $(document).on("change blur input", ".func-input", function(){
        renderCurrentFunction();
    })
    $(document).on("click", ".add-function", function(){
         renderAdditionalFunctionInput();
    });
    $(document).on("click", ".remove-function", function(){
        removeFunction($(this));
        $("#plotted-function").html("");
        renderCurrentFunction();
    })
}

function emptyFunctionInput(){
    return '<div class="mb-1 input-group"><input type="text" class="function form-control w-auto func-input d-inline" placeholder="x^2"><button class="ms-1 btn btn-light-danger text-danger remove-function"><i class="mdi mdi-delete"></i></button></div>';
}


function addButton(){
    return '<div class="text-center mt-2"><button class="btn btn-light-success text-success add-function w-50 btn-rounded"><i class="fa fa-plus-circle"></i></button></div>';
}

function renderFunctions(functions:Array<Function>){
    let html = '';
    if (functions.length == 0){
        html = emptyFunctionInput();
    } else {
        let html = '';
        functions.forEach((item) => {
            html += '<div class="mb-1 input-group"><input type="text" class="function form-control w-auto func-input d-inline" value="' + item.fn + '" placeholder="x^2"><button class="ms-1 btn btn-light-danger text-danger remove-function"><i class="mdi mdi-delete"></i></button></div>';
        })
    }
    html += addButton();
}

function renderAdditionalFunctionInput(){
    const html = emptyFunctionInput();
    $("#functions").append(html);
}

function removeFunction(btn){
    btn.parent().remove();
    if ($(".func-input").length == 1){
        $(".remove-function").remove();
    }
}

function isChecked(data:Object, option:string){
    let s = '';
    if (data.hasOwnProperty(option)){
        if (data[option] == "true" || data[option] == true){
            s = ' checked';
        }
    }
    return s;
}



function objValue(data:Object, option:string){
    let s = '';
    if (data.hasOwnProperty(option)){
        s = ' value="' + data[option] + '"';
    }
    return s;
}

function renderFunctionsInput(data:GraphData){
    let s = '';
    if (data.hasOwnProperty("functions") && data.functions.length > 0){
        let i = 0;
        data.functions.forEach((func) => {
            i += 1;
            s += renderFunctionField(i, func.fn);
        });
    } else {
        s += renderFunctionField();
    }
    return s;
}

function renderFunctionField(iterator = 1, func:string|boolean=false):string{
    let value = '';
    if (func){
        value = ' value="' + func + '"';
    }
    let s = '<div class="mb-1 input-group"><input type="text" class="function form-control w-auto func-input" placeholder="x^2" ' + value + '>'
    if (iterator > 1){
        s += '<button class="ms-1 btn btn-light-danger text-danger remove-function"><i class="mdi mdi-delete"></i></button>';
    }
    s += '</div>';
    return s;
}



const createGraphModal = (editor:Editor, command:string,  data:GraphData): void => {

    const height = (data.height !== undefined) ? data.height : 350;
    const width = (data.width !== undefined) ? data.width : 550;

    const content = '<div class="graph-modal">' +
    '<div class="row" style="min-height: 350px;">' +
        '<div class="col-sm-12 col-md-4 p-3">' + 
                '<h5 class="card-title">Funktion(en)</h5>' + 
                '<div id="functions">' + 
                renderFunctionsInput(data) + 
                '</div>' + 
                addButton() + 
                '<div class="graph-axes">' + 
                    '<h5 class="card-title mt-2">Achsen </h5>' + 
                    '<div class="row x-info mt-1">' + 
                        '<div class="col-sm-1 pe-1">' +
            //               '<b>x</b>' + 
                        '</div>' + 
                        '<div class="col-sm-5 px-1">' + 
                            'Beschriftung' +
                        '</div>' + 
                        '<div class="col-sm-3 px-1">' + 
                            'von' +
                        '</div>' + 
                        '<div class="col-sm-3 px-1">' + 
                            'bis' +
                        '</div>' + 
                    '</div>' + 
            //        '<h6 class="card-title mt-2">x - Achse</h6>' + 
                    '<div class="row x-info mt-1 align-items-center">' + 
                        '<div class="col-sm-1 pe-1">' +
                            '<b>x</b>' + 
                        '</div>' + 
                        '<div class="col-sm-5 px-1">' + 
                            '<input type="text" class="form-control x-label func-input" value="' + data.xAxis.label + '">'+
                        '</div>' + 
                        '<div class="col-sm-3 px-1">' + 
                            '<input type="number" step=".5" class="form-control x-start func-input" value="' + data.xAxis.domain[0] + '">'+
                        '</div>' + 
                        '<div class="col-sm-3 px-1">' + 
                            '<input type="number" step=".5" class="form-control x-end func-input" value="' + data.xAxis.domain[1] + '">'+
                        '</div>' + 
                    '</div>' + 
        //          '<h6 class="card-title mt-2">y - Achse</h6>' + 
                    '<div class="row y-info mt-1 align-items-center">' + 
                        '<div class="col-sm-1 pe-1">' + 
                            '<b>y</b>' + 
                        '</div>' +
                        '<div class="col-sm-5 px-1">' + 
                            '<input type="text" class="form-control y-label func-input" value="' + data.yAxis.label + '">'+
                        '</div>' + 
                        '<div class="col-sm-3 px-1">' + 
                            '<input type="number" step=".5" class="form-control y-start func-input" value="' + data.yAxis.domain[0] + '">'+
                        '</div>' + 
                        '<div class="col-sm-3 px-1">' + 
                            '<input type="number" step=".5" class="form-control y-end func-input" value="' + data.yAxis.domain[1] + '">'+
                        '</div>' + 
                    '</div>' + 
                '</div>' + 
                '<h5 class="card-title mt-2">Einstellungen</h5>' + 
                '<div class="form-check">' +
                    '<input class="form-check-input success check-light-success func-input" type="checkbox" id="integral" ' + isChecked(data, "integral") + '>' +
                    '<label class="form-check-label" for="integral">Integral</label>' +
                '</div>' + 
                '<div class="form-check">' +
                    '<input class="form-check-input success check-light-success func-input" type="checkbox" id="gitter" ' + isChecked(data, "grid") + '>' +
                    '<label class="form-check-label" for="gitter">Gitter</label>' +
                '</div>' + 
            '<input id="width" type="hidden" value="' + width + '">' + 
            '<input id="height" type="hidden" value="' + height + '">' + 
        '</div>' + 
        '<div class="col-sm-12 col-md-8">' +
            '<div class="function-error text-center text-muted" style="display:none;">Derzeitige Eingabe nicht gültig</div>' + 
            '<div class="d-flex align-items-center justify-content-center">' +
            '<div id="plotted-function"></div>' +  
            '</div>' + 
        '</div>' + 
    '</div>' + 
    '</div>';
    const settings = {
        submitBtn: {
            text: 'Einfügen',
            class: 'add-graph',
        },
        size: 'xl',
    }

    const modalId = "create-graph";
    const onclick = function(modal){

        const data = getDataFromModal(modal);
        if (data){
            editor.execCommand(command, data)
            return true;
        }
    }
    const modal = makeEditorModal(modalId, 'Graph Erstellen', content, settings, onclick);

    renderCurrentFunction();
}

function getDataFromModal(modal){
    return getFunctionData(modal);
}


function insertGraph(data:GraphData, editor: Editor){

   // let b64 = getSvgB64(document.getElementsByClassName("function-plot")[0]);

    const btn = $(".add-graph");

    const svg = new XMLSerializer().serializeToString(document.getElementsByClassName("function-plot")[0]);

    const canvas = document.createElement( "canvas" );
    canvas.width = $(".function-plot").width();
    canvas.height = $(".function-plot").height();
    const ctx = canvas.getContext( "2d" );
    ctx.fillStyle = "rgb(255,255,255)";
    ctx.fillRect(0,0,550,350);

    const img = document.createElement( "img" );
    img.setAttribute( "src", "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg))) );

    img.onload = function() {
        ctx.drawImage( img, 0, 0 );

        // Now is done
        const b64 = canvas.toDataURL( "image/png");
    
        b64ToImg(data, editor, b64, insertGraphicToEditor, btn);

    }

}

function insertGraphicToEditor(data:GraphData, editor:Editor, url:string){

    const html = transformGraphForInsert(data, url);
    insertToEditor(html, editor);

}

function addDimensionsToData(data:any):GraphData{
    const f = $(".graph-modal");
    data.width = f.find("#width").val();
    data.height = f.find("#height").val();
    return data;
}

export function transformGraphForInsert(data:GraphData, url:string){
    data.type = "graph";
    data.id = uniqueRandomId(5);

    data = addDimensionsToData(data);

    const json = toJsonHtml(data);
    const html = '<img id="graph" data-json="' + json + '" width="' + data.width + 'px" height="' + data.height + 'px" class="mceNonEditable prop-item prop-graph" src="' + url + '">'
    return html;
}


export function transformGraph(data:GraphData, displayCodeObj:boolean|HTMLElement = false){

    

    if (displayCodeObj && $(displayCodeObj).attr('width') !== undefined){
        data["width"] = parseInt($(displayCodeObj).attr('width').replace("px", ""));
        data["height"] = parseInt($(displayCodeObj).attr('height').replace("px", ""));
    } else {
        data = addDimensionsToData(data);
    }


    // let id = uniqueRandomId(5);
    // if (data.id !== undefined){
    //     id = data.id;
    // }

    const id = data.id;
    // delete data.id;


    const html = '<div id="' + id + '" class="display-graph prop-item prop-load-item d-inline-block" data-json="' + toJsonHtml(data) + '"></div>'; 
    return html;
}


